import React from 'react';
import styled from 'styled-components';
import { useLanguageContext } from '../../context/language_context';
import { MdLanguage } from 'react-icons/md';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguageContext();

  return (
    <Wrapper>
      <button className='lang-btn' onClick={toggleLanguage} aria-label='Toggle language'>
        <MdLanguage className='lang-icon' />
        <span className='lang-text'>{language === 'ar' ? 'EN' : 'ع'}</span>
      </button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .lang-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: transparent;
    color: #4a4a4a;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    font-size: 0.75rem;
    font-weight: 600;
    transition: all 0.3s ease;
    font-family: inherit;
  }

  .lang-btn:hover {
    background: #f5f5f5;
    color: #111718;
  }

  .lang-icon {
    display: none;
  }

  .lang-text {
    font-family: 'Arial', sans-serif;
    font-weight: 700;
    font-size: 0.75rem;
  }

  @media (min-width: 768px) {
    .lang-btn {
      width: auto;
      height: 36px;
      padding: 0 0.75rem;
      border-radius: 0.375rem;
      gap: 0.375rem;
      border: 1px solid #e0e0e0;
    }

    .lang-btn:hover {
      border-color: #17bfcf;
      background: rgba(23, 191, 207, 0.05);
    }

    .lang-icon {
      display: block;
      font-size: 1.125rem;
    }

    .lang-text {
      font-size: 0.875rem;
    }
  }
`;

export default LanguageToggle;
